import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./DialogWindow.scss";
import CrossSvg from "../../assets/svg/CrossSvg";
import gsap from "gsap";

function DialogWindow({ isOpen, setIsOpen, isRendering, setIsRendering, children, description = "" }) {
    const backRef = useRef(null);
    const dialogRef = useRef(null);
    const bodyRef = useRef(document.body);

    useEffect(() => {
        const body = bodyRef.current;
        if (isOpen) {
            body.style.overflow = "hidden";
            body.style.touchAction = "none";
        }

        if (backRef.current && dialogRef.current) {
            if (isOpen) {
                gsap.fromTo(backRef.current, {opacity: 0}, {opacity: 1, duration: .3, ease: "power2.out"})
                gsap.fromTo(dialogRef.current, {opacity: 0, scale: .6}, {opacity: 1, scale: 1, duration: .3, ease: "power2.out"})
            } else if (!isOpen && isRendering) {
                gsap.to(backRef.current, {opacity: 0, duration: .2, ease: "power2.in"})
                gsap.to(dialogRef.current, {opacity: 0, scale: .6, duration: .2, ease: "power2.in", onComplete: () => setIsRendering(false)})
            }
        }

        return () => {
            body.style.overflow = "";
            body.style.touchAction = "";
        };
    }, [isOpen, isRendering, setIsRendering])

    const onClickClose = () => {
        setIsOpen(false);
        setIsRendering(true);
    }

    if (!isOpen && !isRendering) return null;

    return ReactDOM.createPortal(
        <div className="dialog-back" ref={backRef} onClick={onClickClose}>
            <div className="dialog-wrapper" ref={dialogRef} onClick={(e) => e.stopPropagation()}>
                <div className="dialog-header">
                    <div className="dialog-header-center">
                        <div className="title">{description}</div>
                    </div>
                    <div className="dialog-header-right" onClick={onClickClose}>
                        <CrossSvg />
                    </div>
                </div>

                <div className="dialog-content">
                    {children}
                </div>
            </div>
        </div>,
        document.getElementById("dialog-root")
    )
};

export default DialogWindow;